import { Icon } from '@iconify/react'
import { Dropdown, useGlobalState } from '@pepper/ui'

import { ReactComponent as PeppertypeIcon } from 'assets/images/pepperdocs.svg'

import s from './CreateItemDropdown.module.css'

type Props = {
  onCreateOrderClick: () => void
  onCreatePrivateDocClick: () => void
  children: React.ReactNode
  disabled?: boolean
  isMarketplaceDisabled?: boolean
}

export const CreateItemDropdown = ({
  onCreateOrderClick,
  onCreatePrivateDocClick,
  children,
  disabled = false,
  isMarketplaceDisabled,
}: Props) => {
  const { permissions } = useGlobalState()
  const isMarketplaceEnabled =
    permissions?.marketplace && !isMarketplaceDisabled
  const isPepperDocsEnabled = permissions?.pepperDoc

  const menu = (
    <div className={s.wrapper}>
      <button
        className={s.btn}
        onClick={onCreateOrderClick}
        disabled={!isMarketplaceEnabled}
      >
        <Icon
          icon="uil:users-alt"
          width={22}
          height={22}
          enableBackground="new 0 0 24 24"
          color="var(--color-yellow-700)"
        />
        <span>Order Item from Expert Talent</span>
        <Icon icon="lucide:arrow-right" width={16} height={16} />
      </button>

      <button
        className={s.btn}
        onClick={onCreatePrivateDocClick}
        disabled={!isPepperDocsEnabled}
      >
        <PeppertypeIcon title="Peppertype.ai Logo" />
        <span>Create Item with PepperDocs</span>
        <Icon icon="lucide:arrow-right" width={16} height={16} />
      </button>
    </div>
  )

  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      placement="topLeft"
      disabled={disabled}
    >
      {children}
    </Dropdown>
  )
}
